{
  "SearchAvailabilityInput": {
    "availability": "Availability",
    "clear": "Clear",
    "from": "From",
    "to": "To",
    "date": "Date",
    "selectDates": "Select dates"
  },
  "ResourceMetaFilters": {
    "available": "Available"
  },
  "GenericSearch": {
    "Filter": "Filter",
    "Tags": "Tags",
    "Belongs to me": "Belongs to me",
    "Published only": "Published only",
    "Drafts only": "Drafts only",
    "Last week": "Last week",
    "Show archived": "Show archived",
    "sorts": {
      "Created": "Created",
      "Updated": "Updated"
    }
  },
  "TagsFilter": {
    "Tags": "Tags",
    "matchAll": "Match all",
    "matchAny": "Match any",
    "addTag": "Add tag",
    "add": "Add"
  },
  "SearchSorts": {
    "sortBy": "Sort by",
    "sorts": {
      "Created": "Created",
      "Updated": "Updated",
      "Booking Status": "Booking Status"
    }
  },
  "StatusSelectorMultiple": {
    "filterStatus": "Filter Status",
    "showAll": "Show All"
  },
  "ResourceAdvancedSearch": {
    "addFilters": "Add Filters",
    "clearAll": "Clear all"
  },
  "SearchField": {
    "editGroups": "Edit groups",
    "clear": "Clear",
    "labels": {
      "Location": "Location",
      "Tags": "Tags",
      "Groups": "Groups",
      "Rates": "Rates"
    },
    "select": "Select",
    "search": "Search {{label}}",
    "measurementsUnitsInfo": "Filtering will search across all units",
    "searchLocation": "Search location",
    "currency": {
      "select": "Select",
      "searchPlaceholder": "Search {{label}}"
    },
    "singleSelect": {
      "defaultPlaceholder": "Search for an option"
    },
    "tagSelect": {
      "defaultPlaceholder": "Search for a tag"
    },
    "multiSelect": {
      "defaultPlaceholder": "Search for an option"
    },
    "resourceSelect": {
      "defaultPlaceholder": "Search for a resource"
    },
    "searchTypes": {
      "LONG_TEXT": {
        "eq": "Equals"
      },
      "PERCENTAGE": {
        "eq": "Equals"
      },
      "SHORT_TEXT": {
        "eq": "Equals",
        "s_with": "Starts with",
        "e_with": "Ends with",
        "contains": "Contains"
      },
      "BOOLEAN": {
        "eq": "Equals"
      },
      "NUMBER": {
        "eq": "Equals",
        "gte": "Greater than",
        "lte": "Lower than"
      },
      "CURRENCY": {
        "eq": "Equals",
        "gte": "Greater than",
        "lte": "Lower than"
      },
      "MULTI_SELECT": {
        "match": "Match",
        "any": "Any"
      },
      "TAG_SELECT": {
        "match": "Match",
        "any": "Any"
      },
      "RESOURCE_SELECT": {
        "match": "Match"
      },
      "SINGLE_SELECT": {
        "eq": "Equals"
      },
      "DATE": {
        "eq": "Equals"
      },
      "URL": {
        "eq": "Equals"
      },
      "MEASUREMENT": {
        "eq": "Equals",
        "gte": "Greater than",
        "lte": "Lower than"
      },
      "NETSUITE_VENDOR": {
        "eq": "Equals"
      },
      "HEIGHT": {
        "eq": "Equals",
        "gte": "Greater than",
        "lte": "Lower than"
      },
      "NETSUITE_PO": {
        "eq": "Equals"
      }
    },
    "matchingTypes": {
      "matchingType": "Matching type",
      "match": "Match all",
      "any": "Match any"
    }
  },
  "TagInput": {
    "add": "Add",
    "add_many": "Add"
  },
  "SelectResourceGroup": {
    "groups": "Groups",
    "all": "All",
    "groupSelected": "{{count}} Group selected",
    "groupSelected_all": "All groups",
    "groupSelected_other": "{{count}} Groups selected"
  },
  "NoteItem": {
    "archive": "Archive"
  },
  "EventDateRange": {
    "labelStart": "Starts",
    "labelEnd": "Ends",
    "addAnotherDate": "Add another date"
  },
  "EventHoursInput": {
    "hoursLabel": "Hours"
  },
  "EventHelper": {
    "allDay": "All day",
    "recurringLabel": "{{hours}}h{{minutes}} / day"
  },
  "Loading": {
    "justAMoment": "Just a moment"
  },
  "FileUploader": {
    "uploading": "Uploading",
    "complete": "Complete",
    "dragFilesHereOr": "Drag Files Here or",
    "clickToUpload": "Click to Upload",
    "maxFileUploadSize": "Maximum file upload size exceeded."
  },
  "FileUploadingItem": {
    "untitledFile": "Untitled File",
    "failed": "FAILED",
    "complete": "COMPLETE"
  },
  "EventHoursInputOptions": {
    "allDay": "All day",
    "hoursPerDay": "Hours per day",
    "hours": "Hours",
    "minutes": "Minutes",
    "specificTimes": "Specific times",
    "from": "From",
    "to": "To"
  }
}
